import { GiftShopClient } from '../../../generated/mlmbox/client/gift_shop/gift_shop.client';
import { transport } from '../../../utils/constants';

export const giftShopClient = new GiftShopClient(transport);
